import { Component } from '@angular/core';

@Component({
    selector: 'ui-skeleton-cell',
    templateUrl: './skeleton-cell.component.html',
    styleUrls: ['./skeleton-cell.component.scss']
})
export class UISkeletonCellComponent {}
